module.exports = __webpack_public_path__ + "static/media/sfaa-bg2.6fb8041e.png";